export default {
    ChatRoomEdit: {
        path: "apps/Chat/ChatRoomEditApp"
    },
    ChatBg: {
        path: "apps/Chat/ChatBgApp"
    },
    GridTrash: {
        path: "apps/Grid/GridTrashApp"
    },
    GridLinkedTab: {
        path: "apps/Grid/GridLinkedTabApp"
    },
    GridDataChangeLog: {
        path: "apps/Grid/GridDataChangeLogApp"
    },
    AuthWatcherApp: {
        path: "apps/AuthWatcher/AuthWatcherApp"
    },
    ExpiredTokenWatcherApp: {
        path: "apps/ExpiredTokenWatcher/ExpiredTokenWatcherApp"
    },
    Form2: {
        path: "apps/Form2/FormApp"
    },
    Iframe: {
        path: "apps/Iframe/IframeApp"
    },
    DynamicJournalBg: {
        path: "apps/DynamicJournal/DynamicJournalBgApp"
    }
};
